import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  media: null,
  tempSelectedLayout: null,
  layoutData: null, 
};

const screenSlice = createSlice({
  name: "screen",
  initialState,
  reducers: {
    setMedia: (state, action) => {
      state.media = action.payload;
    },
    setTempSelectedLayout: (state, action) => {
      state.tempSelectedLayout = action.payload;
    },
    setLayoutData: (state, action) => {
      state.layoutData = action.payload;
    },
  },
});

export const { setMedia, setTempSelectedLayout, setLayoutData } = screenSlice.actions;
export default screenSlice.reducer;
